import { c as _c } from "react/compiler-runtime";
import { LoadingScreen } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { SettingsTabs } from "@router/route-params";
import { HAS_CREDIT_PURCHASED } from "@src/constants/credit-constants";
import { useCompanyId } from "@context-providers/company-id-provider";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect } from "react";

/**
 * It is a test component that simulates a successful credit purchase.
 * Renders a success page after purchasing credits.
 * Displays a success message and navigates to the subscription settings page.
 */
export function CreditsPurchaseRedirection() {
  const $ = _c(6);
  const {
    trackEvent
  } = useTrackEvent();
  const {
    navigateToSettingsPage
  } = useAppNavigation();
  const companyId = useCompanyId();
  let t0;
  let t1;
  if ($[0] !== companyId || $[1] !== navigateToSettingsPage || $[2] !== trackEvent) {
    t0 = () => {
      localStorage.setItem(HAS_CREDIT_PURCHASED, "true");
      trackEvent({
        name: WorkspaceEvents.purchaseCreditsSuccess
      });
      navigateToSettingsPage({
        companyId,
        settingsTab: SettingsTabs.subscription
      });
    };
    t1 = [companyId, navigateToSettingsPage, trackEvent];
    $[0] = companyId;
    $[1] = navigateToSettingsPage;
    $[2] = trackEvent;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LoadingScreen />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}